import React, { useEffect, useState } from 'react'
import { Autocomplete, Box, Button, Checkbox, Divider, FormControl, FormHelperText, IconButton, InputLabel, Stack, TextField, Typography } from '@mui/material'
import { RootState } from '../../../global/config/store.ts';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ApiCreateBundleAllocation, ApiGetAllocationlist, ApiGetClientEntityByClientGroupId } from '../../../apiService/Core/Apicall.tsx';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { format } from 'date-fns';
import { CancelOutlined } from '@mui/icons-material';

// const tasks = [
//     { taskId: 1, taskName: "Setup Stage", venueName: "Grand Hall" },
//     { taskId: 2, taskName: "Sound Check", venueName: "City Auditorium" },
//     { taskId: 3, taskName: "Lighting Setup", venueName: "Skyline Arena" },
//     { taskId: 4, taskName: "Security Briefing", venueName: "Regal Grounds" },
//     { taskId: 5, taskName: "Catering Arrangements", venueName: "Emerald Banquet" },
//     { taskId: 6, taskName: "Guest Coordination", venueName: "Silver Plaza" },
//     { taskId: 7, taskName: "Decoration", venueName: "Sunset Pavilion" },
//     { taskId: 8, taskName: "Photography Setup", venueName: "Moonlight Hall" },
//     { taskId: 9, taskName: "Registration Desk", venueName: "Crystal Center" },
//     { taskId: 10, taskName: "Final Rehearsal", venueName: "Orchid Venue" }
// ];

function CreateBundleAllocation() {
    const [clientEntityList, setClientEntityList] = useState<any>([]);
    const [clientEntityId, setClientEntityId] = useState<any>(null);
    const Clientlist = useSelector((state: RootState) => state.client.clientList);
    const [selectedClient, setSelectedClient] = useState<any>(null);
    const [ClientId, setClientId] = useState(null);
    const [currentDate, setCurrentDate] = useState(new Date());
    const [reportMonth, setReportMonth] = useState<number>(currentDate.getMonth() + 1);
    const [reportYear, setReportYear] = useState<number>(currentDate.getFullYear());
    const [checkboxes, setCheckboxes] = React.useState<any[]>([]);
    const [task, settask] = React.useState<any[]>([]);
    const [filteredTasks, setfilteredTasks] = React.useState<any>(task);
    const [bundleTasks, setbundleTasks] = React.useState<any>([]);
    const [bundleName, setbundleName] = React.useState<string>('');
    const navigate = useNavigate()


    const handleChange = (taskId: number) => (event: React.ChangeEvent<HTMLInputElement>) => {
        setCheckboxes((prev) => (
            {
                ...prev,
                [taskId]: event.target.checked

            }));
    };




    useEffect(() => {
        if (Clientlist.length > 2) {
            setSelectedClient(Clientlist[2]);
            setClientId(Clientlist[2].clientGroupName);
        }
    }, [Clientlist]);

    useEffect(() => {
        if (clientEntityList.length > 1) {
            setClientEntityId(clientEntityList[0]?.clientEntityId);
        }
    }, [clientEntityList]);

    useEffect(() => {
        handleGetClientList();
    }, [ClientId]);

    useEffect(() => {
        const getallocationlist = async () => {
            const data = `?allocationStatus=created&offset=0&limit=1000&jobMonth=${reportMonth}&jobYear=${reportYear}&allocationClientGroup=${selectedClient?.clientGroupName}&clientEntityId=${clientEntityId}`
            try {
                const response = await ApiGetAllocationlist(data)
                settask(response.data)

            } catch (error) {
                alert(error)
            }
        }
        getallocationlist()
    }, [reportMonth, reportYear, clientEntityId, selectedClient])

    const handleGetClientList = async () => {
        const data = `?ClientGroupName=${ClientId}`;
        if (!ClientId) return;
        try {
            const res: any = await ApiGetClientEntityByClientGroupId(data);
            setClientEntityList(res.data);
        } catch (error) {
        }
    };


   


    const handlePrevMonth = () => {
        if (bundleTasks.length > 0) {
            const isEmptyBundle = window.confirm("You will loose your currunt Bulndle alocation list");

            if (isEmptyBundle) {
                setCurrentDate((prevDate) => {
                    const newDate = new Date(prevDate.getFullYear(), prevDate.getMonth() - 1, 1);
                    setReportMonth(newDate.getMonth() + 1);
                    setReportYear(newDate.getFullYear());
                    return newDate;
                });
                setbundleTasks([])
            }
        }
        else {
            setCurrentDate((prevDate) => {
                const newDate = new Date(prevDate.getFullYear(), prevDate.getMonth() - 1, 1);
                setReportMonth(newDate.getMonth() + 1);
                setReportYear(newDate.getFullYear());
                return newDate;
            });
        }
    };

    const handleNextMonth = () => {
        if (bundleTasks.length > 0) {
            const isEmptyBundle = window.confirm("You will loose your currunt Bulndle alocation list");
            if (isEmptyBundle) {
                setCurrentDate((prevDate) => {
                    const newDate = new Date(prevDate.getFullYear(), prevDate.getMonth() + 1, 1);
                    setReportMonth(newDate.getMonth() + 1);
                    setReportYear(newDate.getFullYear());
                    return newDate;
                });
                setbundleTasks([])
            }
        }
        else {
            setCurrentDate((prevDate) => {
                const newDate = new Date(prevDate.getFullYear(), prevDate.getMonth() + 1, 1);
                setReportMonth(newDate.getMonth() + 1);
                setReportYear(newDate.getFullYear());
                return newDate;
            });
        }
    };

    const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newDate = new Date(event.target.value + "-01");
        if (bundleTasks.length > 0) {
            const isEmptyBundle = window.confirm("You will loose your currunt Bulndle alocation list");
            if (isEmptyBundle) {
                setCurrentDate(newDate);
                setReportMonth(newDate.getMonth() + 1);
                setReportYear(newDate.getFullYear());
                setbundleTasks([])
            }
        }
        else {
            setCurrentDate(newDate);
            setReportMonth(newDate.getMonth() + 1);
            setReportYear(newDate.getFullYear());
        }
    };






    // useEffect(() => {
    //     const filtered = task.filter((item) => checkboxes[item.allocationId])
    //     setbundleTasks(filtered)
    // }, [checkboxes, task])
    useEffect(() => {
        const filtered = task.filter((item) => checkboxes[item.allocationId]);

        setbundleTasks((prev) => {
            // Create a Map to avoid duplicates based on allocationId
            const existingMap = new Map(prev.map(item => [item.allocationId, item]));

            // Add or update with new filtered items
            filtered.forEach(item => {
                existingMap.set(item.allocationId, item);
            });

            return Array.from(existingMap.values());
        });
    }, [checkboxes, task]);

    const removeBundle = (taskId: number) => {
        const filteredBundle = bundleTasks.filter(item => item.allocationId !== taskId)
        setbundleTasks(filteredBundle)
        setCheckboxes((prev) => (
            {
                ...prev,
                [taskId]: false

            }));

    }

    const createbundle = async () => {
        if (bundleName !== '' && bundleTasks.length > 0) {
            const data = {
                bundleName: bundleName,
                month: reportMonth,
                year: reportYear,
                allocations: bundleTasks.map(item => ({
                    allocationId: item.allocationId,
                    venueIds: String(item.venueId.venueId)
                }))
            }
            try {
                const response = await ApiCreateBundleAllocation(data);
                if(response.status){
                    navigate('/admin/allocations/bundle-allocations')
                }
                alert(response.message)
            } catch (error) {
                alert(error)
            }
            // console.log("Send Data", data)
        }
        else if (bundleName == '') {
            alert('Enter Bundle Name')
        }
        else if (bundleTasks.length == 0) {
            alert('Select allocations to create bundle')
        }
    }

    return (
        <Box className='bg-white pt-5'>
            <div className="d-flex align-items-center justify-content-between px-3 mb-1">
                <Box className='d-flex align-items-center gap-5'>
                    <Stack direction="row" className="" spacing={2}>
                        <FormControl size="small" sx={{ width: 180 }}>
                            <Autocomplete
                                disablePortal
                                id="mm-autocomplete"
                                options={Clientlist}
                                value={selectedClient}
                                getOptionLabel={(option) => option?.clientGroupName}
                                isOptionEqualToValue={(option, value) =>
                                    option.clientGroupDBName === value.clientGroupDBName
                                }
                                onChange={(event, newValue: any) => {
                                    setSelectedClient(newValue);
                                    setClientId(newValue?.clientGroupName || null);

                                    if (!newValue || (selectedClient && newValue.clientGroupName !== selectedClient.clientGroupName)) {
                                        setClientEntityId(null)
                                        setClientEntityList([])
                                    }
                                }}
                                renderInput={(params) => (
                                    <TextField {...params} label="Select Client" />
                                )}
                                size="small"
                            />
                        </FormControl>
                    </Stack>
                    <Stack className="ml-2" direction="row" spacing={2}>
                        <FormControl size="small" sx={{ width: 400 }}>
                            <Autocomplete
                                disablePortal
                                id="beacon-autocomplete"
                                options={clientEntityList.filter(
                                    (item) => item.clientEntityId !== null
                                )} // filter out invalid entries
                                getOptionLabel={(option) => option?.entityName || ""} // properly show label
                                onChange={(event, newValue: any) => {
                                    setClientEntityId(newValue?.clientEntityId || null);
                                }}
                                value={
                                    clientEntityList.find(
                                        (option) => option?.clientEntityId === clientEntityId
                                    ) || null
                                }
                                defaultValue={clientEntityList[0]?.clientEntityId}
                                renderInput={(params) => (
                                    <TextField {...params} label="Select Business" />
                                )}
                                size="small"
                            />
                        </FormControl>
                    </Stack>
                </Box>
                <h1 className="">Bundle Allocations</h1>

                {/* <Box className='col-6 d-flex juastify-content-start'> */}
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        // marginTop: "20px"
                    }}
                >
                    <IconButton onClick={handlePrevMonth}>
                        <ChevronLeftIcon />
                    </IconButton>
                    <Box sx={{ display: "flex", alignItems: "center", mx: 2 }}>
                        <input
                            type="month"
                            onChange={handleDateChange}
                            value={format(currentDate, "yyyy-MM")}
                            className="primary-color"
                            style={{
                                border: "none",
                                background: "none",
                                fontSize: "1.25rem",
                                fontWeight: "bold",
                                cursor: "pointer",
                                fontFamily: "inherit",
                            }}
                        />
                    </Box>
                    <IconButton onClick={handleNextMonth}>
                        <ChevronRightIcon />
                    </IconButton>
                </Box>
                {/* </Box> */}
                {/* <div className="add-button common-manage-button">
                    <Button
                        variant="contained"
                        onClick={() => addOrUpdateVenue()}
                        className="table-row-background "
                    >
                        Add New Site
                    </Button>
                   
                </div>{" "} */}
            </div>
            <Divider className='mx-4 mb-2' />

            <Box height='calc(100vh - 380px)' className='d-flex align-items-start  justify-content-between'>
                <Box className='col-8 h-100 p-3'>
                    <Box className='d-flex flex-wrap align-items-center justify-content-start'  maxHeight='calc(100vh - 450px)' overflow='auto' gap={2}>
                        {task.map((item: any) => (
                            <Box className='border d-flex align-items-start p-2 col-3' sx={{ borderRadius: '10px' }} maxWidth='24%' gap={1} key={item.allocationId}>
                                <Checkbox
                                    className='m-0 p-0'
                                    checked={checkboxes[item.allocationId] || false}
                                    onChange={handleChange(item.allocationId)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />
                                <Box>
                                    <Typography lineHeight='1' className='fw-bold m-0 p-0' variant='h6'>{item.venueId.venueName}</Typography>
                                    <Typography className='m-0 p-0' variant='subtitle2'>{item.taskName}</Typography>
                                </Box>
                            </Box>

                        ))}
                    </Box>
                </Box>
                <Divider orientation='vertical' />
                <Box className='col-4 h-100 p-3'>
                    <Typography className='text-center mb-3' variant='h5'>Selected Allocation</Typography>
                    <Box className='d-flex flex-wrap align-items-center' maxHeight='calc(100vh - 450px)' overflow='auto' gap={1}>
                        {bundleTasks && bundleTasks.map(item => (
                            <Box className='border d-flex align-items-start justify-content-between p-3 col-6' sx={{ borderRadius: '10px' }} maxWidth='49%' key={item.allocationId}>
                                <Box>
                                    <Typography lineHeight='1' className='fw-bold m-0 p-0' variant='h6'>{item.venueId.venueName}</Typography>
                                    <Typography className='m-0 p-0' variant='subtitle2'>{item.taskName}</Typography>
                                </Box>
                                <IconButton className='p-0' onClick={() => { removeBundle(item.allocationId) }}><CancelOutlined className='p-0' /></IconButton>
                            </Box>

                        ))}
                    </Box>
                </Box>
            </Box>
            <Divider className='mx-4 my-3' />
            <Box className='d-flex px-3 align-items-center justify-content-end' gap={2}>
                <FormControl className="w-25 my-0 mb-3 ">
                    {/* <InputLabel shrink={false}>Bundle Name: </InputLabel> */}
                    <TextField
                        className="w-100"
                        label="Bundle Name"
                        placeholder="Enter Bundle Name..."
                        variant="outlined"
                        fullWidth
                        value={bundleName}
                        onChange={(e) => setbundleName(e.target.value)}
                    />
                    {/* { && <Typography className="text-danger">{formik.errors.questions}</Typography>} */}

                </FormControl>
                <Box className='extra'>
                    <Button className="bg-grey transform px-5 text-light" onClick={() => { createbundle() }}>
                        Create
                    </Button>
                </Box>
            </Box>
        </Box>
    )
}

export default CreateBundleAllocation
